import { MOBILE_NUMBER_FIELD } from '@/data/DirectToDoctor/direct-to-doctor-steps';
import { formatPhoneNumberToInternational } from '@/utils/phone-number';
import { Stack } from '@montugroup/design-system';
import { useFormBuilder } from '@montugroup/form-builder';
import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import {
  ButtonRow,
  ConfirmNumberDialog,
  DialogHeading,
  MobileNumber,
  StyledButton,
} from './ConfirmMobileNumberDialog.styles';

let openListener: (() => void) | null = null;

export const requestMobileNumberConfirmation = () => {
  openListener?.();
};

export const ConfirmMobileNumberDialog = () => {
  const [open, setOpen] = useState(false);
  const { watch, getValues } = useFormContext();
  const { currentStepIndex, setNewCurrentStepIndex } = useFormBuilder();

  const checkMobileNumber = watch(MOBILE_NUMBER_FIELD);

  useEffect(() => {
    openListener = () => setOpen(true);
    return () => {
      openListener = null;
    };
  }, []);

  const handleConfirm = () => {
    setOpen(false);
    setNewCurrentStepIndex(currentStepIndex + 1, getValues, () => {});
  };

  return (
    <ConfirmNumberDialog open={open} onClose={() => setOpen(false)} maxWidth="xs" fullWidth>
      <Stack>
        <DialogHeading variant="h6" component="h2">
          The mobile number you entered is:
        </DialogHeading>
        <MobileNumber variant="h6" component="p">
          {formatPhoneNumberToInternational(checkMobileNumber)}
        </MobileNumber>
        <ButtonRow>
          <StyledButton fullWidth variant="outlined" onClick={() => setOpen(false)}>
            Back
          </StyledButton>
          <StyledButton fullWidth variant="contained" onClick={handleConfirm}>
            This is correct
          </StyledButton>
        </ButtonRow>
      </Stack>
    </ConfirmNumberDialog>
  );
};
